<template>
    <div>
        <rkm-modal
            extraLarge
            ref="RkmModal"
            title="Visita domiciliar"
            no-close-on-backdrop
            no-close-on-esc
        >

            <Form
                ref="Form"
                :item="item"
                :data="data"
                @closeModal="closeModal"
            />

            <template
                v-slot:footer="{ cancel }"
            >
                <rkm-button
                    @click="cancel"
                >
                    Cancelar
                </rkm-button>

                <rkm-button
                    @click="$refs.Form.save()"
                    color="primary"
                >
                    Salvar
                </rkm-button>
            </template>
        </rkm-modal>
    </div>
</template>

<script>
import { mapActions } from 'vuex'
import Form from "@/components/atencao-basica/visita-domiciliar/components/residentes/Form";

// Mixins.
import { repository, stringCase, object, formats } from '@/mixins'

export default {
    components: {
        Form
    },
    computed: {
        fields() {
            return {
                tables: {
                    residentes: [
                        { key: 'nome', label: 'Nome',  sortable: true },
                        { key: 'cns', label: 'CNS', class: 'col-min text-center', sortable: true },
                        { key: 'prontuario', label: 'Prontuário', class: 'col-min text-center', sortable: true },
                        { key: 'actions', label: 'Ações', class: 'col-min' },
                    ],
                },
            }
        },
    },
    created() {
        this.repositories = {
            visitaDomiciliar: this.getConectaSusRepository('atencaoBasica.visitaDomiciliar'),
        }
    },
    data: () => ({
        item: null
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        open(item) {

            this.item = item
            this.$refs.RkmModal.show()
        },
        getResidentes(item) {

            this.setLoading()

            const request = {
                pacienteId: item.id,
            }

            this.repositories.visitaDomiciliar.getResidentes(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => {
                    this.items = Object.assign(response.data)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        cancel() {

            this.$emit('closeModal')
            this.$refs.RkmModal.hide()
        },
        formataCns(item){
            return item.cns ? this.formatCns(item.cns) : '-'
        },
        search(item) {

            this.$router.push({ name: 'atencao-basica-visita-domiciliar-list', params: { id: item.id } })
        },
        save() {

            this.$refs.Form.save()
        },
        closeModal() {

            this.$refs.RkmModal.hide()
        }
    },
    mixins: [ repository, stringCase, object, formats ],
    props: {
        data: { type: Object, required: false },
        residentes: { type: Array, required: false },
        origem: { type: String },
    }
}
</script>

<style scoped>
.warning {
    color: var(--warning);
}
</style>